import { TemplateAttribute } from './template-attribute';
import { TemplateAttributeType } from './template-attribute-type.enum';
export class TemplateArea {

  uuid: string;
  titleDictionaryKey: string;
  helpDictionaryKey: string;
  sortOrder: number;
  cssStyle: string;
  choice: string;
  choiceAttribute: TemplateAttribute;
  attributes: TemplateAttribute[] = [];

  constructor(templateArea: any) {

    this.uuid = templateArea.uuid;
    this.titleDictionaryKey = templateArea.titleDictionaryKey;
    this.helpDictionaryKey = templateArea.helpDictionaryKey;
    this.sortOrder = templateArea.sortOrder;
    this.cssStyle = templateArea.cssStyle;
    this.choice = templateArea.choice;

    if (this.choice != null && this.choice.length > 0) {
      this.choiceAttribute = new TemplateAttribute({
        key: 'choice_' + this.choice + '_' + this.uuid, type: TemplateAttributeType.BOOLEAN
      });
      this.choiceAttribute.choiceSelected = false;
    }

    if (templateArea.attributes != null) {
      for (const attribute of templateArea.attributes) {
        this.attributes.push(new TemplateAttribute(attribute));
      }
    }
  }
}
